import { createNotificationsApi } from '../api/notifications.api';
import { auth } from '@core/utils/firebase/firebase';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { Auth } from '@angular/fire/auth';
import { Notification, PaginatedNotification } from '@core/interfaces/api';

const notificationsApi = createNotificationsApi(auth as Auth);

export function useNotificationByIdQuery(id: number) {
  const { data, isLoading, error } = useQuery<Notification, Error>({
    queryKey: ['notification', id],
    queryFn: () => notificationsApi.getNotificationById(id),
    enabled: !!id,
  });

  return {
    notification: data,
    isLoading,
    error,
  };
}

export function useNotificationsQuery({
  siteId,
  page,
  rowsPerPage,
  sortField,
  sortOrder,
  search,
}: {
  siteId: number;
  page: number;
  rowsPerPage: number;
  sortField: string;
  sortOrder: 'asc' | 'desc';
  search?: string;
}) {
  const { data, isLoading, error, refetch } = useQuery<
    PaginatedNotification,
    Error
  >({
    queryKey: [
      'notifications',
      siteId,
      page,
      rowsPerPage,
      sortField,
      sortOrder,
      search,
    ],
    queryFn: () =>
      notificationsApi.getNotifications(siteId, {
        page,
        pageSize: rowsPerPage,
        sortField,
        sortOrder,
        search,
      }),
    enabled: !!siteId,
    placeholderData: keepPreviousData,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
}
